<div class="app-layout-wrapper">
  <mat-sidenav-container class="app-sidenav-container">
    <mat-sidenav class="app-sidenav" mode="side" opened>
      <div fxLayoutAlign="center center" class="pt-45 pb-25">
        <img
          [routerLink]="['/']"
          class="clickable"
          height="94"
          src="assets/images/aument-logo.png"
        />
      </div>
      <mat-nav-list>
        <mat-list-item
          *ngFor="let item of navigationItems"
          [routerLink]="[item.route]"
          [routerLinkActive]="['active-link']"
          [routerLinkActiveOptions]="{ exact: item.route === '/' }"
          #rla="routerLinkActive"
          class="nav-item"
        >
          <div class="item-icon">
            <img
              src="assets/images/nav-items/{{
                rla.isActive ? item.iconActive : item.icon
              }}.svg"
              alt="{{ item.name }}"
            />
          </div>
          <span class="font-chakra font-lg-14">{{
            item.name | translate
          }}</span>
          <div
            *ngIf="hasUnreadMessages && item.route === '/inbox'"
            class="yellow-dot"
          ></div>
          <img
            *ngIf="rla.isActive"
            class="menu-arrow"
            src="assets/images/nav-items/menu_arrow.svg"
            alt="menu arrow"
          />
        </mat-list-item>
      </mat-nav-list>
    </mat-sidenav>
    <mat-sidenav-content>
      <div class="aum-container">
        <div class="mb-30" fxLayoutAlign="space-between center">
          <div fxLayout="column">
            <div fxLayout="row">
              <mat-icon
                *ngIf="previousRoute"
                [routerLink]="previousRoute"
                class="back-icon text-white"
                matPrefix
                >west</mat-icon
              ><span class="font-chakra font-30 font-lg-22 text-white">{{
                title | translate
              }}</span>
            </div>
            <span class="font-lg-12">{{
              currentDate | localizedDate: 'medium'
            }}</span>
          </div>
          <div *ngIf="client" fxLayout="row" fxLayoutGap="20px">
            <div fxLayout="column" fxLayoutAlign="center end" class="header-name">
              <span class="bold text-white"
                >{{ client.firstName }} {{ client.lastName }}
              </span>
              <span class="font-lg-12">{{ client.email }}</span>
            </div>
            <img
              [routerLink]="['settings']"
              class="profile-img clickable"
              [src]="(client?.profileImageUrl | secureImage | async)"
              alt="profile"
            />
            <div class="logout-button">
              <button mat-icon-button (click)="logout()">
                <img
                  src="assets/images/icons/dashboard_logout.svg"
                  alt="logout"
                />
              </button>
            </div>
          </div>
        </div>

        <router-outlet></router-outlet>
      </div>
    </mat-sidenav-content>
  </mat-sidenav-container>
</div>
